import { render, staticRenderFns } from "./CustomerManufacturerDiscount.vue?vue&type=template&id=542a8fb6&"
import script from "./CustomerManufacturerDiscount.vue?vue&type=script&lang=js&"
export * from "./CustomerManufacturerDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports